import { useState } from 'react';
import { MdCheck } from 'react-icons/md';
import { toast } from 'react-hot-toast';
import { approveMedicalProfessional } from '~/services/medical-professionals';
import { formatDateIfValid } from '~/utils';
import VerifyModal from './VerifyModal';

interface Props {
  medProf: any;
}

const MedicalProfessionalTitlePanel: React.FC<Props> = ({ medProf }) => {
  const isActive = medProf?.is_active
  const [isVerified, setIsVerified] = useState(!!medProf?.approved_by_person_id)
  const [isLoading, setIsLoading] = useState(false)
  const [verifyModalOpen, setVerifyModalOpen] = useState(false)
  const fullName = `${medProf?.person?.first_name ?? ''} ${
    medProf?.person?.last_name ?? ''
  }`.trim()

  const handleVerifyClick = () => {
    if (isVerified || !isActive) return;
    setVerifyModalOpen(true);
  };

  const approveMedicalProfessionalApiCall = async () => {
    setIsLoading(true)

    approveMedicalProfessional(medProf.id).then(() => {
      setIsVerified(true)
      setVerifyModalOpen(false)
      toast.success('Medical professional verified')
    }).catch((error: any) => {
      toast.error(error?.message || 'Failed to verify medical professional')
    }).finally(() => {
      setIsLoading(false)
    })


  }
  function getByText() {
    if (!isActive) return "Not Active";
    if (isLoading) return "Verifying...";

    return isVerified ? "Verified" : "Verify";
  }


  return (
    <>
      <div className='md:flex md:justify-between'>
        <div className='mb-6 md:mb-0'>
          <div className='flex'>
            <h1 className='text-[38px]/[44px]'>
              {medProf?.person?.first_name} {medProf?.person?.last_name}
            </h1>
            <div className='ml-[7px] mt-[7px] w-[16px]'>
              {isVerified ? (
                <MdCheck color='#6BB841' size={40} />
              ) : (
                ''
              )}
            </div>
          </div>

          <div className='flex'>
            <div
              className={`inline-flex rounded-full px-3 py-1 text-sm hover:bg-opacity-90 ${
                isActive
                  ? 'bg-primary'
                  : 'bg-whiten text-secondary'
              }`}
            >
              {isActive ? 'Active' : 'Inactive'}
            </div>
            <div className='ml-[15px] text-[16px]/[24px] text-[#949599]'>
              Last Updated:{' '}
              {formatDateIfValid(medProf?.update_date, 'MM/dd/yy')}
            </div>
          </div>
        </div>

        <div className='md:flex'>
          <button
            className={`m-auto mr-3 rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 ${
              isVerified
                ? 'cursor-default border-[#6BB841] bg-[#6BB841] text-white'
                : 'border-warning bg-warning text-black hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
            }`}
            onClick={handleVerifyClick}
            disabled={isVerified || !isActive}
          >
            {getByText()}
          </button>
        </div>
      </div>
      <VerifyModal
        isOpen={verifyModalOpen}
        name={fullName}
        isLoading={isLoading}
        onCancel={() => setVerifyModalOpen(false)}
        onConfirm={approveMedicalProfessionalApiCall}
      />
    </>
  );
};

export default MedicalProfessionalTitlePanel;
